<div
  data-testid="point-score"
  class="container {{themeService?.isDarkMode ? 'dark' : 'light'}} {{summaryView ? 'summary-view' : ''}}"
  [style.backgroundColor]="
    matchStatus === 'COMPLETED' && setWinner ? 'rgba(255, 128, 139, 0.1)' : null
  "
>
  {{ gameScore || "0" }}
</div>
